import React from 'react';
import { withTranslation } from 'react-i18next';
import { Box } from '@mui/material';

import ButtonTooltip from '@core/dashboard/components/ButtonTooltip';
import UserAvatar from '@components/UserAvatar';
import UserProfileModal from '@components/UserProfileModalNew';

import { IUserAvatarButtonView } from './interfaces';
import { useStyle } from './styles';

const UserAvatarButtonView = ({
  profileImage = '',
  name = '',
  showUserSettingModal,
  toggleModal,
  t: translate,
}: IUserAvatarButtonView) => {
  const classes = useStyle();

  return (
    <>
      <ButtonTooltip title={translate('tooltips.myAccount')}>
        <Box sx={classes.root} data-testid="user-profile-avatar-btn">
          <UserAvatar
            name={name}
            onClick={toggleModal}
            src={profileImage}
            sx={classes.avatar}
          />
        </Box>
      </ButtonTooltip>

      <UserProfileModal isOpen={showUserSettingModal} onClose={toggleModal} />
    </>
  );
};

export default withTranslation()(UserAvatarButtonView);
